import {Pipe, PipeTransform} from '@angular/core';
import {LocalizedTextDto} from '../dtos/localized-text.dto';
import {TranslocoService} from '@jsverse/transloco';

@Pipe({
  name: 'localizedText'
})
export class LocalizedTextPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {
  }

  transform(value: LocalizedTextDto[] | undefined, ...args: unknown[]): unknown {
    if (!value) {
      return undefined;
    }

    const language = this.translocoService.getActiveLang();

    let localizedText = value.find(text => text.language === language);
    if ((!localizedText || !localizedText.value) && value.length > 0) {
      localizedText = value.find(text => text.language === 'en');
    }

    if ((!localizedText || !localizedText.value) && value.length > 0) {
      localizedText = value.find(text => text.value);
    }

    return localizedText?.value;
  }
}
